import React, { FC, memo } from 'react'
import styled, { css } from 'styled-components'

import { Link, LinkProps } from '@Components/Link'

// This is important for structured data! See https://developers.google.com/search/docs/advanced/structured-data/breadcrumb
type BreadcrumbItem = {
  name: string
  position?: number
}

export type CrumbProps = LinkProps & BreadcrumbItem

const CrumbWrapper = styled.li(() => css`
  flex-wrap: wrap;
  align-items: center;

  a {
    flex-shrink: 0;
    text-transform: uppercase;
    &:hover {
      text-decoration: underline;
    }
  }

  & + & {
    &:before {
      content: '/';
      display: inline-block;
      padding: 0 10px;
    }
  }
`)

export const Crumb: FC<CrumbProps> = memo(({ children, name, position = 0, ...linkProps }) => (
  <CrumbWrapper key={`${name}${linkProps.href}`} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
    {linkProps.href
      ? (
        <Link
          itemProp="item"
          {...linkProps}
        >
          {children
            ? (
              <>
                <meta content={name} itemProp="name" />
                {children}
              </>
            )
            : <span itemProp="name">{name}</span>}
        </Link>
      )
      : <span itemProp="name">{name}</span>}
    <meta content={`${position + 1}`} itemProp="position" />
  </CrumbWrapper>
))
